<template>
    <ul class="navbar-nav me-auto mb-2 mb-xl-0">
        <input type="hidden" :value="VerItems">

        <template v-for="(itemMenu,index) in pArrayMenus">
            <li v-if="VerificarMenuVisible(itemMenu.Permiso,itemMenu.EsDeRoot)" :key="index" :class="itemMenu.SubMenus.length>0?'nav-item dropdown':'nav-item'">
                <template v-if="parseInt(itemMenu.TipoBoton) == 0">
                    <span v-if="itemMenu.SubMenus.length>0">
                        <a class="nav-link dropdown-toggle cursor-pointer" href="#" :id="'dropdown'+index" data-bs-toggle="dropdown" aria-expanded="false">
                            <i :class="itemMenu.Icono"></i>
                           {{itemMenu.Nombre}}
                        </a>
                        <ul class="dropdown-menu" :aria-labelledby="'dropdown'+index">
                            <li v-for="(itemSubmenu,index2) in itemMenu.SubMenus" :key="index2">

                                <template v-if="parseInt(itemSubmenu.TipoBoton) == 0">
                                    <router-link v-if="VerificaSubMenuVisible(itemSubmenu.Permiso,itemSubmenu.EsDeRoot)" :to="{ name: itemSubmenu.Router, params: itemSubmenu.Parametros}" class="dropdown-item"> 
                                        {{itemSubmenu.Nombre}}
                                    </router-link>
                                </template>
                                
                                <template v-else>
                                    <a v-if="VerificaSubMenuVisible(itemSubmenu.Permiso,itemSubmenu.EsDeRoot)" @click="IrARutaSub(itemSubmenu,'SubMenu')" class="dropdown-item cursor-pointer">
                                        {{itemSubmenu.Nombre}}
                                    </a>
                                    <!-- <router-link v-if="VerificaSubMenuVisible(itemSubmenu.Permiso,itemSubmenu.EsDeRoot)" :key="index2"  :to="{ name: itemSubmenu.Router, params:{pListaSubMenus:itemSubmenu.Apartados, parametros:itemSubmenu.Parametros}}" class="dropdown-item"> 
                                        {{itemSubmenu.Nombre}}
                                    </router-link> -->
                                </template>

                            </li>
                        </ul>
                    </span>

                    <span v-else>
                        <router-link :to="{ name: itemMenu.Router, params: itemMenu.Parametros}" class="nav-link cursor-pointer">
                            <i :class="itemMenu.Icono"></i>
                            {{itemMenu.Nombre}}
                        </router-link>
                    </span>
                </template>

                <template v-else>
                    <a v-if="VerificarMenuVisible(itemMenu.Permiso,itemMenu.EsDeRoot)" @click="IrARutaSub(itemMenu,'Menu')" class="nav-link cursor-pointer">
                        <i :class="itemMenu.Icono"></i>
                        {{itemMenu.Nombre}}
                    </a>

                    <!-- <router-link :to="{ name: itemMenu.Router, params: {pListaSubMenus:itemMenu.SubMenus, parametros:itemMenu.Parametros}}" class="nav-link">
                        <i :class="itemMenu.Icono"></i>
                        {{itemMenu.Nombre}}
                    </router-link> -->
                </template>
            </li>
        </template>

        <slot name="MenuDerecho"></slot>
    </ul>
</template>
<script>

export default {
  components: {},
    props:['pArrayMenus','pMenus','pSubMenus','pApartados','pVerMenu'],
    name:'htmlArregloMenus',
    data() {
        return {
            ListMenus: [],
			ListSubMenus: [],
			ListApartados: [],
			VerMenu: 0,
        }
    },
    methods:{
        VerificarMenuVisible(Clave,EsDeRoot)
		{
            let user = JSON.parse(sessionStorage.getItem("user"));
            if(EsDeRoot==1 && parseInt(user.IdPerfil) != 1){
                return false;
            }

            if(this.VerMenu>0){
				return true;
			}
        
			let Val = (this.ListMenus != undefined) ? this.ListMenus.find( item => item.Clave == Clave) : false;
			if (!Val) return false;
			
            return true;
		},
		VerificaSubMenuVisible(Clave,EsDeRoot)
		{
            let user = JSON.parse(sessionStorage.getItem("user"));
            if(EsDeRoot==1 && parseInt(user.IdPerfil) != 1){
                return false;
            }

            if(this.VerMenu>0){
				return true;
			}

			let Val = (this.ListSubMenus != undefined) ? this.ListSubMenus.find( item => item.Clave == Clave) : false;

			if (!Val) return false;
			
            return true;
		},
        IrARutaSub(item,Tipo)
        {
            let arreglo = [];
            let arregloAsignados = [];

            sessionStorage.removeItem('oSubMenus');
            sessionStorage.removeItem('oPanelesAsignados');
            sessionStorage.removeItem('oAsignadoPrincipal');

            if(Tipo == 'Apartado'){
                sessionStorage.setItem('oSubMenus',JSON.stringify(item.SubApartados));
                sessionStorage.setItem('oPanelesAsignados',JSON.stringify(this.ListApartados));

                arreglo = item.SubApartados;
                arregloAsignados = this.ListApartados;
            }
            else if(Tipo == 'SubMenu'){
                sessionStorage.setItem('oSubMenus',JSON.stringify(item.Apartados));
                sessionStorage.setItem('oPanelesAsignados',JSON.stringify(this.ListApartados));

                arreglo = item.Apartados;
                arregloAsignados = this.ListApartados;
            }
            else if(Tipo == 'Menu'){
                sessionStorage.setItem('oSubMenus',JSON.stringify(item.SubMenus));
                sessionStorage.setItem('oPanelesAsignados',JSON.stringify(this.ListSubMenus));

                arreglo = item.SubMenus;
                arregloAsignados = this.ListSubMenus;
            }

            sessionStorage.setItem('oAsignadoPrincipal',this.VerMenu);
            
            this.$router.push({name:'panelSubMenus', params:{}});
            this.bus.$emit('BusquedaMenus',arreglo,arregloAsignados)
        },
    },
    computed:{
        VerItems()
        {
            if (this.pMenus != undefined){
                this.ListMenus = this.pMenus;
            }
            if (this.pSubMenus != undefined){
                this.ListSubMenus = this.pSubMenus;
            }
            if (this.pApartados != undefined){
                this.ListApartados = this.pApartados;
            }
            if (this.pVerMenu != undefined){
                this.VerMenu = this.pVerMenu;
            }

            return 1;
        }
    }
}
</script>